<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
                    <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
                        <div class="modal-container" @click.stop>

                            <div class="flex-header" style="justify-content: space-between;">
                                <div>
                                    <h2 class="transporter-title">Rute Ekspedisi</h2>
                                </div>
                                <div>
                                    <div class="modal-close" @click="$emit('closeModal')">
                                        <i class="fal fa-times fa-2x"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body">
                                
                                <div style="max-height: 500px; max-width: 800px;">
                                    <table class="modal-stats">
                                    <tr>
                                        <th>NO TO</th>
                                        <td class="wrap-text" style="max-width: 650px;">{{ propData.no_to }}</td>
                                    </tr>
                                    <tr>
                                        <th>NOPOL</th>
                                        <td>{{ propData.nopol }}</td>
                                    </tr>
                                </table>

                                <div class="divider"></div>

                                <div class="row w-100" v-if="data && data.child.length > 0">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-12">

                                        <div class="rute-card row w-100" v-for="dat in data.child" :key="dat.nomor">
                                            <div class="col-2" style="align-items: center;">
                                                <div class="rute-urutan-box">
                                                    <p v-if="dat.nomor != 0">{{ zeroPad(dat.nomor, 2) }}</p>
                                                    <p v-else><i class="fas fa-question" style="color: grey;"></i></p>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <p class="dealer--name">{{ dat.kd_dealer }}</p>
                                                <p class="dealer--address">{{ dat.address }}</p>
                                            </div>
                                            <div class="col-2">
                                                <div class="mb-4">
                                                    <p class="dealer--distance text-center pr-4">Kode Dealer</p>
                                                </div>
                                                <div>
                                                    <p class="dealer--distance text-center pr-4">{{ dat.dealer_code }}</p>
                                                </div>
                                            </div>
                                            <div class="col-2">
                                                <p class="dealer--distance text-center">+/- {{ dat.distance }}Km</p>
                                            </div>
                                            <div class="col-2">
                                                <div class="mb-4">
                                                    <p class="dealer--distance text-center pr-4">Kode OTP</p>
                                                </div>
                                                <div>
                                                    <p class="dealer--distance text-center pr-4">{{ dat.no_otp }}</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-md-2"></div>
                                </div>
                                <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else-if="data.length == 0">
                                    <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">No Data</p>
                                </div>
                                <div style="min-height: 400px; display: flex; align-items: center; justify-content: center;" v-else>
                                    <p style="margin: 0; font-size: 40px; text-shadow: 2px 2px 2px grey">Loading...</p>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
            }
        },
        props : ['propData'],
        mounted() {
            this.fetchData();  
        },
        methods: {
            fetchData () {
                // this.$http.get(`/api/validation/rute-ekspedisi?no_to=TO/20211220/00000807&nopol=W9001P`)
                this.$http.get(`/api/validation/rute-ekspedisi?no_to=${this.propData.no_to}&nopol=${this.propData.nopol}`)
                .then((resp)=>{
                    this.data = resp.data.data;
                })
                .catch((err)=>{console.log(err)});
            },
            zeroPad (num, places) {
                return String(num).padStart(places, '0')
            }
        }
    }
</script>

<style scoped>
    .flex-header{
        display: flex;
    }

    .wrap-text {
        word-wrap: break-word;
    }

    .transporter-title {
        font-family: 'Poppins';
        font-size: 20px;
        font-weight: medium;

        padding: 20px 25px;
        margin: 0;
    }

    .modal-close {
        background-color: #F2F2F2;
        color: black;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        border-top-right-radius: 8px;

        cursor: pointer;
        transition: background-color .3s ease;
    }

    .modal-close:hover {
        background-color: #E0E0E0;
    }

    .modal-mask {
        position: fixed;
        z-index: 1020;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        /* padding: 20px 30px; */
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .modal-default-button {
        float: right;
    }

    /*
      * The following styles are auto-applied to elements with
      * transition="modal" when their visibility is toggled
      * by Vue.js.
      *
      * You can easily play with the modal transition by editing
      * these styles.
      */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body {
        margin: 0
    }

    .modal-body .moduleLine {
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a {
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover {
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox {
        border: 1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color: black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i {
        font-size: 5vh;
    }

    h3.modalHeadline {
        margin: 0 0 20px 0;
        font-weight: bold;
        text-align: center;
    }

    /* MODAL ENDS */

    /* ==========================================================================
    #FORM made by Colorlib (https://colorlib.com)
    ========================================================================== */
    input {
        outline: none;
        margin: 0;
        border: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        width: 100%;
        font-size: 14px;
        font-family: inherit;
    }

    .input--style-4 {
        line-height: 50px;
        background: #fafafa;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        padding: 0 20px;
        font-size: 16px;
        color: #666;
        -webkit-transition: all 0.4s ease;
        -o-transition: all 0.4s ease;
        -moz-transition: all 0.4s ease;
        transition: all 0.4s ease;
    }

    .input--style-4::-webkit-input-placeholder {
        /* WebKit, Blink, Edge */
        color: #666;
    }

    .input--style-4:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #666;
        opacity: 1;
    }

    .input--style-4::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #666;
        opacity: 1;
    }

    .input--style-4:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #666;
    }

    .input--style-4:-ms-input-placeholder {
        /* Microsoft Edge */
        color: #666;
    }

    .label {
        font-size: 16px;
        color: #555;
        text-transform: capitalize;
        display: block;
        margin-bottom: 5px;
    }

    .radio-container {
        display: inline-block;
        position: relative;
        padding-left: 30px;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .radio-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .radio-container input:checked~.checkmark {
        background-color: #e5e5e5;
    }

    .radio-container input:checked~.checkmark:after {
        display: block;
    }

    .radio-container .checkmark:after {
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 12px;
        height: 12px;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        background: #57b846;
    }

    .checkmark {
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        left: 0;
        height: 20px;
        width: 20px;
        background-color: #e5e5e5;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
        box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .input-group {
        position: relative;
        /* margin-bottom: 22px; */
        padding: 20px;
    }

    .input-group-icon {
        position: relative;
    }

    .input-icon {
        position: absolute;
        font-size: 18px;
        color: #999;
        right: 18px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
    }

    /* ==========================================================================
       #TITLE made by Colorlib (https://colorlib.com)
       ========================================================================== */
    .title {
        font-size: 40px;
        color: #525252;
        /* margin-bottom: 40px; */
        text-align: center;
    }

    .sub--title {
        color: red;
        margin-bottom: 40px;
        text-align: center;
    }

    .modal-body {
        max-height: 80vh;
        overflow-y: auto;
        overflow-x: auto;
    }

    .innerBox {
        padding: 0.8em 1.5em;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        background-color: white;
        box-shadow: 2px 2px 5px #E0E0E0;
    }

    .hoverable:hover {
        cursor: pointer;
    }

    .modal-stats {
        margin: 0 auto;
    }

    .modal-stats th {
        font: normal normal normal 13px/20px Poppins;
        padding-right: 20px;
    }

    .modal-stats td {
        font: normal normal normal 20px/28px Poppins;
    }

    .divider {
        width: 100%;
        height: 3px;
        background-color: grey;
    }

    .rute-card {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 6px #83838329;
        border-radius: 8px;
        margin: 20px 0;
        padding: 20px 0;
    }

    .rute-card>div { 
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
    }

    .rute-card .rute-urutan-box {
        border: 5px solid #F77070;
        border-radius: 200px;

        height: 50px;
        width: 50px;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rute-card .rute-urutan-box p {
        font: normal normal normal 16px/18px Poppins;
        font-weight: bold;
        margin: 0
    }

    .rute-card .dealer--name {
        font: normal normal 500 18px/20px Poppins;
        margin-bottom: 10px;
        color: #606060;
    }

    .rute-card .dealer--address {
        font: normal normal 500 14px/16px Poppins;
        margin: 0;
        color: #606060;
    }

    .rute-card .dealer--code {
        font: normal normal 500 18px/20px Poppins;
        margin-bottom: 10px;
        color: #606060;
    }

    .rute-card .dealer--distance {
        font: normal normal 500 14px/16px Poppins;
        margin: 0;
        color: #606060;
    }
</style>